// Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfigStaging = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY_STAGING,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_STAGING,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_STAGING,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_STAGING,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_STAGING,
  appId: process.env.REACT_APP_FIREBASE_APP_ID_STAGING,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_STAGING,
};

export const firebaseConfigProd = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY_PROD,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_PROD,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_PROD,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_PROD,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_PROD,
  appId: process.env.REACT_APP_FIREBASE_APP_ID_PROD,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_PROD,
};

export const actionCodeSettingsStaging = {
  url: process.env.REACT_APP_FIREBASE_EMAIL_REDIRECT_STAGING || '',
  handleCodeInApp: true,
};

export const actionCodeSettingsProd = {
  url: process.env.REACT_APP_FIREBASE_EMAIL_REDIRECT_PROD || '',
  handleCodeInApp: true,
};

export const actionCodeSettings =
  process.env.REACT_APP_ENV === 'production'
    ? actionCodeSettingsProd
    : actionCodeSettingsStaging;

export const COMPANY_URL = 'https://yotutor.com/';

// Feature Flags
// Feature flags are now configured in src/config/staging.json and src/config/production.json
// They are loaded and accessed via src/utils/featureFlags.ts
// See src/config/README.md for documentation


